class StorageComponent {
  storage: any;

  constructor(storage: any) {
    this.storage = storage;
  }

  set(key: string, value: any) {
    this.storage.setItem(
      key,
      typeof value === 'string' ? value : JSON.stringify(value)
    );
  }

  get(key: string) {
    const value = this.storage.getItem(key);
    const condition = value
      ? value.indexOf('}') > value.indexOf('{') ||
        value.indexOf(']') > value.indexOf('[')
      : false;
    const valueResult = condition ? JSON.parse(value) : value;
    return value ? valueResult : null;
  }

  remove(key: string) {
    this.storage.removeItem(key);
  }

  clear() {
    this.storage.clear();
  }

  setObject(key: string, value: any) {
    this.storage.setItem(key, JSON.stringify(value));
  }

  getObject(key: string) {
    return this.storage.getItem(key) ? JSON.parse(this.storage.getItem(key)) : {};
  }
}

export const LocalStorage =
  typeof localStorage !== 'undefined' ? new StorageComponent(localStorage) : null;

export const SessionStorage =
  typeof sessionStorage !== 'undefined'
    ? new StorageComponent(sessionStorage)
    : null;
